import { render, staticRenderFns } from "./shop.view.vue?vue&type=template&id=0033e9a4&scoped=true"
import script from "./shop.view.vue?vue&type=script&lang=js"
export * from "./shop.view.vue?vue&type=script&lang=js"
import style0 from "./shop.view.vue?vue&type=style&index=0&id=0033e9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033e9a4",
  null
  
)

export default component.exports